/**
 * Per-user Waffle **flag** gating the Care Key Savings tab, resolved at the nav entry so the tab is
 * absent rather than empty for anyone without it.
 *
 * A flag rather than a switch because this tab exists to be assessed: a handful of stakeholders
 * review the data before it is visible to everyone. The row is created and users attached manually
 * in Django Admin (never via migration); a missing flag resolves to inactive, so the tab stays
 * hidden until someone turns it on.
 */
export const FLAG_CRM_CARE_KEY_SAVINGS_TAB = 'care_key_savings.crm_tab'

/**
 * Per-user Waffle flag gating the Clinical Medications tab, resolved at the nav entry the same way,
 * so a few clinical reviewers check the synced Elation rows before every provider sees them.
 */
export const FLAG_CRM_MEDICATIONS_TAB = 'medications.crm_tab'
